module.exports = __webpack_public_path__ + "img/SES_160250001.9851b20d.jpg";